import { useToastStore } from "./toastStore";
const push = (input) => useToastStore.getState().push(input);
/**
 * Imperative toast API — callable from anywhere, no React context needed.
 *   toast.success("Сохранено")
 *   toast.error("Не удалось", "Ошибка")
 *   toast.show({ tone: "info", title, message, duration })
 */
export const toast = {
    show: (input) => push(input),
    info: (message, title) => push({ tone: "info", message, title }),
    success: (message, title) => push({ tone: "success", message, title }),
    error: (message, title) => push({ tone: "error", message, title }),
    warning: (message, title) => push({ tone: "warning", message, title }),
    dismiss: (id) => useToastStore.getState().dismiss(id),
};
// ── Mantine-compatible shim ──────────────────────────────────
// Lets existing `notifications.show({ title, message, color })` call sites
// migrate by swapping only the import path. New code should use `toast.*`.
const COLOR_TO_TONE = {
    green: "success",
    teal: "success",
    red: "error",
    orange: "warning",
    yellow: "warning",
    blue: "info",
    gray: "info",
};
export const notifications = {
    show: (opts) => push({
        tone: opts.color ? COLOR_TO_TONE[opts.color] ?? "info" : "info",
        title: opts.title,
        message: opts.message,
        duration: opts.autoClose === false ? 0 : opts.autoClose,
    }),
};
